/**
* 提现申请 首页
*/
<template>
	<div style="display: flex;flex-direction: column; height: 89vh;">

		<!-- 数据加载提示框 -->
		<van-overlay :show="loadingData" @click="show = false">
			<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
				<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
			</div>
		</van-overlay>

		<!-- 第一行搜索条件 -->
		<div style="margin: 0 5px; display: flex;">

			<el-form ref="form" label-width="80px">
				<el-form-item label="搜索时间">
					<el-date-picker v-model="value" type="daterange" @change="selectTime" start-placeholder="开始日期"
						end-placeholder="结束日期" :default-time="['00:00:00', '23:59:59']">
					</el-date-picker>
				</el-form-item>
			</el-form>

			<el-form ref="form" :model="form" label-width="80px">
				<el-form-item label="申请状态" style="width: 300px;">
					<el-select v-model="form.activityRegion" clearable placeholder="请选择申请状态" @change="select">
						<!-- 0审核中 1已通过 2未通过 3已完成 -->
						<el-option label="审核中" value="0"></el-option>
						<el-option label="已通过" value="1"></el-option>
						<el-option label="未通过" value="2"></el-option>
						<el-option label="已完成" value="3"></el-option>
					</el-select>
				</el-form-item>
			</el-form>

			<el-input style="margin-left: 15px; margin-right: 10px; height: 20px;" placeholder="请输入内容" v-model="input1"
				label-width="60px">
				<template slot="prepend">申请人ID</template>
			</el-input>

			<el-button style="margin-left: 5px; height: 40px;" type="primary" icon="el-icon-search"
				@click="search()">搜索</el-button>

		</div>



		<!-- 列表 -->
		<el-table :data="tableData" height="200" stripe border style="width: 100%; flex: 1; overflow: auto;">
			<el-table-column type="index" :index="indexMethod" align="center"></el-table-column>
			<el-table-column prop="createTime" label="申请时间" align="center" width="164" sortable></el-table-column>
			<el-table-column label="用户ID" align="center" width="94">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<p style="font-size: 14px;">{{ scope.row.userId }}</p>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="realName" label="真实姓名" align="center" width="144"></el-table-column>
			<el-table-column prop="idCardNo" label="身份证号码" align="center" width="164"></el-table-column>
			<el-table-column prop="withdrawAmount" label="提现金额" align="center" width="94"></el-table-column>
			<el-table-column prop="currency" label="币种" align="center" width="94"></el-table-column>
			<el-table-column label="提现状态" align="center">
				<template slot-scope="scope">
					<div slot="reference" class="name-wrapper">
						<!-- （//0审核中 1已通过 2未通过 3已完成 -->
						<p v-show="scope.row.withdrawStatus==0" style="font-size: 14px; color: #0000FF;">审核中</p>
						<p v-show="scope.row.withdrawStatus==1" style="font-size: 14px; color: #008000;">已通过</p>
						<p v-show="scope.row.withdrawStatus==2" style="font-size: 14px; color: #FF0000;">未通过</p>
						<p v-show="scope.row.withdrawStatus==3" style="font-size: 14px; color: #008000;">已完成</p>
					</div>
				</template>
			</el-table-column>

			<el-table-column fixed="right" label="操作" width="100" align="center">
				<template slot-scope="scope">
					<el-button @click="querySimCard(scope.$index)" type="text" size="small">查看详情</el-button>
				</template>
			</el-table-column>

		</el-table>

		<!-- 页码 -->
		<div class="block"
			style="flex-shrink: 0; width: 100%; height: 60px; display: flex; align-items: center; justify-content: center;">
			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[20, 30, 40,50,100,200]" layout="total, sizes, prev, pager, next, jumper" :total="total">
			</el-pagination>
		</div>

	</div>
</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	export default {
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				value: '', //时间
				startTime: 0, //开始时间
				endTime: 0, //结束时间
				form: {
					activityRegion: '', // 根据需要添加其他表单字段
				},
				typeId: 0, //申请类型
				input1: '', //用户ID
				pageSize: 20, //每页条数
				pageNum: 1, //当前页数
				total: 0, //一共有多少条数据
				tableData: null, //列表数据
				//...
			};
		},
		mounted() {
			this.fetchData(this.pageNum, this.pageSize); //语音房 提现申请列表
		},
		methods: {
			fetchData(pageNum, pageSize) { //语音房 提现申请列表
				this.loadingData = true;

				this.pageSize = pageSize;
				this.pageNum = pageNum;

				const requestData = {}; //传递的参数
				requestData.pageSize = pageSize;
				requestData.pageNum = pageNum;

				if (this.input1.length > 0) { //申请用户的ID
					requestData.userId = this.input1;
				}
				if (this.startTime > 0) { //开始时间
					requestData.startTime = this.startTime;
				}
				if (this.endTime > 0) { //结束时间
					requestData.endTime = this.endTime;
				}
				if (this.typeId > 0) { //提现状态
					requestData.withdrawStatus = this.typeId;
				}


				console.log("语音房 提现申请列表  发送的数据：", requestData)

				axios.post(this.$p_url + '/voiceRoom/H5/getH5VoiceRoomWithdrawRecords', requestData, {
						withCredentials: true, // 允许跨域携带 cookie
						headers: {
							'Content-Type': 'application/json', // 设置请求头为 JSON，根据后端要求适当调整
							'Accept': '*/*',
							'token': Cookies.get("token"),
						},
					})
					.then(response => {
						this.loadingData = false;
						console.log("语音房 提现申请列表  后台数据返回：", response.data)
						const state = response.data.state; // 获取状态
						if (state === "authFailed") { //登录失效
							Cookies.remove("token");
							this.$router.push({ //跳转到登录
								path: '/Login1715',
								query: {}
							});
						}
						if (state === "success") { // 检查状态
							this.total = response.data.data.total; //一共有多少条数据

							for (let i = 0; i < response.data.data.list.length; i++) {
								//身份证正面
								response.data.data.list[i].cardFrontImg = this.$p_urlImage + response.data.data.list[i]
									.cardFrontImg;
								//身份证反面
								response.data.data.list[i].cardBackImg = this.$p_urlImage + response.data.data.list[i]
									.cardBackImg;
								//手持身份证
								response.data.data.list[i].cardHandImg = this.$p_urlImage + response.data.data.list[i]
									.cardHandImg;
								//银行卡照片
								response.data.data.list[i].bankImg = this.$p_urlImage + response.data.data.list[i]
									.bankImg;
							}

							this.tableData = response.data.data.list;
						} else {
							alert("服务器错误:" + response.data.message)
						}
					})
					.catch(error => { // 请求失败时处理错误
						this.loadingData = false;
						alert('请求失败:' + error);
					});
			},
			querySimCard(index) { //查看详情
				let page = this.$router.resolve({
					path: '/WithdrawalHomeInfo',
					query: {
						data: JSON.stringify(this.tableData[index]), // 将对象转换为字符串
					}
				});
				window.open(page.href, '_blank');
			},
			agree(index) { //同意
			},
			banAccount(index) { //拒绝
			},
			search() { //单击了搜索
				this.fetchData(1, this.pageSize);
			},
			handleSizeChange(val) { //设置每页多少条
				this.pageSize = val;
				this.fetchData(this.pageNum, val);
			},
			handleCurrentChange(val) { //查询第几页的数据
				this.fetchData(val, this.pageSize);
			},
			indexMethod(index) {
				if (this.pageNum == 1) {
					return index + 1;
				} else {
					return (this.pageNum - 1) * this.pageSize + index + 1;
				}

			},
			selectTime() { //选择了时间
				if (this.value == null) {
					this.startTime = 0;
					this.endTime = 0;
					this.fetchData(1, this.pageSize);
				} else {
					[this.startTime, this.endTime] = this.value;
					// 将时间字符串转换为时间戳
					this.startTime = new Date(this.startTime).getTime();
					this.endTime = new Date(this.endTime).getTime();
					this.fetchData(1, this.pageSize);
				}
			},
			select() { //选中了某个值
				this.typeId = this.form.activityRegion;
				this.fetchData(1, this.pageSize);
			},
			//...
		}
		//...
	}
</script>

<style>
</style>